<template>
    <div class="relative pt-6 pb-12" :class="onPricing ? 'bg-gray-900' : 'bg-white'">
        <div class="max-w-screen-xl px-4 mx-auto sm:px-6">
            <nav class="relative flex items-center justify-between sm:h-10 md:justify-center">
                <div class="flex items-center flex-1 md:inset-y-0 md:left-0 md:absolute">
                    <div class="flex items-center justify-between w-full md:w-auto">
                        <router-link to="/">
                            <img class="w-auto h-8 sm:h-10" src="../assets/logo.png" alt />
                        </router-link>
                        <div class="flex items-center -mr-2 md:hidden">
                            <button
                                @click="open = true"
                                type="button"
                                class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                            >
                                <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="hidden md:flex md:space-x-10">
                    <router-link
                        :to="{ name: 'app-landing', hash: '#features' }"
                        class="ml-10 font-medium transition duration-150 ease-in-out focus:outline-none"
                        :class="onPricing ? 'text-gray-300 hover:text-gray-100 focus:text-gray-100' : 'text-gray-500 hover:text-gray-900 focus:text-gray-900'"
                    >
                        Features
                    </router-link>
                    <router-link
                        to="pricing"
                        class="ml-10 font-medium transition duration-150 ease-in-out focus:outline-none"
                        :class="onPricing ? 'text-gray-300 hover:text-gray-100 focus:text-gray-100' : 'text-gray-500 hover:text-gray-900 focus:text-gray-900'"
                    >
                        Pricing
                    </router-link>
                </div>
                <div class="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0">
                    <a
                        href="https://beta.flowist.io/signin"
                        class="mr-3 text-base font-medium leading-6 text-gray-500 whitespace-no-wrap transition duration-150 ease-in-out hover:text-gray-900"
                    >
                        Sign in
                    </a>
                    <span class="inline-flex rounded-md shadow-sm">
                        <a
                            href="https://beta.flowist.io/signup"
                            class="inline-flex items-center justify-center px-4 py-2 text-base font-medium leading-6 text-white whitespace-no-wrap transition duration-150 ease-in-out border border-transparent rounded-md bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700"
                        >
                            Sign up
                        </a>
                    </span>
                </div>
            </nav>
        </div>

        <div v-if="open" class="absolute inset-x-0 top-0 p-2 md:hidden">
            <div
                class="transition origin-top-right transform rounded-lg shadow-md"
                enter-active-class="transition-all duration-100 ease-out"
                leave-active-class="transition-all duration-100 ease-in"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div class="overflow-hidden bg-white rounded-lg shadow-xs">
                    <div class="flex items-center justify-between px-5 pt-4">
                        <router-link to="/">
                            <img class="w-auto h-8" src="../assets/logo.png" alt />
                        </router-link>
                        <div class="-mr-2">
                            <button
                                @click="open = false"
                                type="button"
                                class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                            >
                                <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="px-2 pt-2 pb-3">
                        <router-link
                            :to="{ name: 'app-landing', hash: '#features' }"
                            class="ml-10 font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-900 focus:outline-none focus:text-gray-900"
                        >
                            Features
                        </router-link>
                        <router-link
                            to="pricing"
                            class="ml-10 font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-900 focus:outline-none focus:text-gray-900"
                        >
                            Pricing
                        </router-link>
                    </div>
                    <div>
                        <a
                            href="https://beta.flowist.io"
                            class="block w-full px-8 py-3 font-medium text-center transition duration-150 ease-in-out bg-white text-pri-600 hover:bg-gray-100 hover:text-indigo-700 focus:outline-none focus:bg-gray-100 focus:text-indigo-700"
                            >Log in</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app-navbar',
    data() {
        return {
            open: false,
        };
    },
    computed: {
        onPricing() {
            return this.$route.path === '/pricing';
        },
    },
};
</script>
